import { YodaFontSize } from 'yoda-ui/yodaTheme';

export const labelStyle = {
  marginTop: '0',
  marginBottom: '10px',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: YodaFontSize.small,
  fontWeight: 300,
  lineHeight: '1.2rem',
};

export const warningLabelStyle = {
  marginTop: '0',
  marginBottom: '10px',
  color: 'rgba(255, 0, 0, 0.6)',
  fontSize: YodaFontSize.small,
  fontWeight: 400,
  lineHeight: '1.2rem',
};
